import styled from 'styled-components';
import DestinationsSide from './DestinationsSide';
import { colorSchema } from 'utils/style';

export default styled(DestinationsSide)`
  .destinations-side {
    display: flex;
    flex-direction: column;
    margin-bottom: 5.2rem;

    &__localization {
      display: flex;
      &:last-of-type {
        .destinations-side__icon-container {
          &:after {
            display: none;
          }
        }
      }
    }

    &__icon-container {
      align-items: center;
      display: flex;
      flex-direction: column;
      margin-right: 0.8rem;

      &:after {
        border: 2px dashed ${colorSchema('grey300')};
        content: '';
        height: 70px;
        margin: 0.4rem 0;
      }
    }

    &__icon {
      background: ${colorSchema('white')};
      border: 4px solid ${colorSchema('grey300')};
      border-radius: 50%;
      height: 16px;
      margin-top: 0.2rem;
      width: 16px;
    }

    &__date {
      margin-bottom: 0.8rem;
    }

    &__date,
    &__location {
      color: ${colorSchema('grey900')};
      font-size: 1.6rem;
      font-weight: bold;
    }

    &__time {
      color: ${colorSchema('grey700')};
      font-size: 1.6rem;
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
  }
`;
